// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/* #__NO_SIDE_EFFECTS__# */
function _AddPrefix(name) {
    return "Microsoft.ApplicationInsights.{0}." + name;
}
export var EventEnvelopeType = ( /*#__PURE__*/_AddPrefix("Event"));
export var ExceptionEnvelopeType = ( /*#__PURE__*/_AddPrefix("Exception"));
export var MetricEnvelopeType = ( /*#__PURE__*/_AddPrefix("Metric"));
export var PageViewEnvelopeType = ( /*#__PURE__*/_AddPrefix("Pageview"));
export var PageViewPerformanceEnvelopeType = ( /*#__PURE__*/_AddPrefix("PageviewPerformance"));
export var RemoteDependencyEnvelopeType = ( /*#__PURE__*/_AddPrefix("RemoteDependency"));
export var RequestEnvelopeType = ( /*#__PURE__*/_AddPrefix("Request"));
export var TraceEnvelopeType = ( /*#__PURE__*/_AddPrefix("Message"));
//# sourceMappingURL=EnvelopeTypes.js.map